import React from 'react'
import Main from './Main'

const PhotoAdmin = () => {
  return <Main />
}

export default PhotoAdmin
